import React, { useState, useEffect, useContext, useRef } from "react";
import Vehicle from "./Vehicle";
import Axios from "axios";
import AppContext from "../context";
import { useTranslation } from "react-i18next";

export default function DriverVehicleView({ v, k, blurred }) {
	// console.log(v);
	const lc = (text) => {
		if (text) return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
		return "";
	};
	const { t } = useTranslation();

	const insurance_unknown = [
		"",
		"**UNKNOWN",
		"n/a",
		"na",
		"unconfirmed",
		"unk",
		"unknown",
		"unknown ",
		"unknown evaded",
		"Unk",
		"Unknown",
		"Unknown ",
		"Unknown - Evaded",
		"Unknown Evaded",
		"Unknown/Evaded",
		"Unknwon",
		"Unkonwn",
		"Unkown",
		"UNKNOWN",
		"N\\A",
		"NONE OR UNKNOWN",
		"NO KNOWN"
	];

	const insurance_none = [
		"",
		"                                 NONE",
		"-NONE PROVIDED-",
		"NOT INSURED",
		"no insurance",
		"none",
		"NO INS",
		"NO INSURANCE",
		"NO INSURANCE ",
		"NO INSURANCE PARKED VEHICLE",
		"NO PROOF",
		"NO PROOF OF INSURANCE",
		"NO PROOF OF INSURANCE OBTAINED",
		"NONE",
		"NONE ",
		"NONE FOUND",
		"NONE FOUND OR PROVIDED",
		"NONE GIVEN",
		"NONE IN VEHICLE",
		"NONE LOCATED",
		"NONE ON REGISTRATION",
		"NONE PROVIDED"
	];

	let insurance = "Yes";
	insurance_unknown.forEach((item) => {
		if (item == v.insurance) {
			insurance = "Unknown";
		}
	});

	insurance_none.forEach((item) => {
		if (item == v.insurance) {
			insurance = "No";
		}
	});

	if (!v.insurance) {
		insurance = "Unknown";
	}

	const guilty =
		v.contributing_factor1 &&
		v.contributing_factor1 !== "N" &&
		v.contributing_factor1 !== "NONE";

	const [zipInfo, setZipInfo] = useState("");

	const { setModal } = useContext(AppContext);

	const popover = useRef();
	const popover3 = useRef();

	useEffect(() => {
		if (v.participants[0] && v.participants[0].city_of_residence) {
			setZipInfo(v.participants[0].city_of_residence);
		} else {
			if (!blurred) {
				Axios.get("accident/zip/" + v.participants[0]?.zip).then((d) => {
					setZipInfo(d.data.result);
				});
			}
		}
	}, []);

	return (
		<div className="driver-vehicle">
			<div className="inner">
				<div>
					<div
						className={
							guilty ? "vehicle-bg-holder" : "vehicle-bg-holder with-popover"
						}
					>
						{<Vehicle v={v} alt />}
						{!guilty && (
							<div className="popover">
								{t("BASED_ON_THE_FOLLOWING")}
								<img src="/assets/icon-arrow.svg" className="arrow" />
								<ul>
									<li>{t("ACCIDENT_SEVERITY")}</li>
									<li>{t("DATE_OF_ACCIDENT_WITHIN_STATUTE_OF_LIMITATION")}</li>
									<li>{t("THE_OTHER_DRIVER_WAS_AT_FAULT")}</li>
								</ul>
								<div className="compensation-popover" ref={popover}>
									{t(
										"THE_DRIVER_OR_PASSENGER_OF_THIS_VEHICLE_MAY_BE_ENTITLED_TO_LEGAL_COMPENSATION_"
									)}
								</div>
								<button
									onClick={() => setModal("carLead-" + k)}
									onMouseOver={() => popover.current.classList.add("show")}
									onMouseOut={() => popover.current.classList.remove("show")}
								>
									<img src="/assets/icon-hammer-2.svg" /> {t("COMPENSATION")}
								</button>
							</div>
						)}
						{v.recallData?.length ? (
							<div
								style={{ textAlign: "center" }}
								onClick={() => setModal("recall-" + k)}
							>
								<img src="/assets/nhtsa.png" height="30" />
								<br />
								<img src="/assets/product-recall.jpg" height="30" />
							</div>
						) : null}
					</div>
				</div>
				<div className="table-holder">
					<h2 style={{ display: "flex", alignItems: "center" }}>
						{lc(v.vehicle_maker)}
						<span>
							{v.vehicle_model_year ? " - " + v.vehicle_model_year : ""}
							{v.vehicle_color ? ", " + lc(v.vehicle_color) : ""}
						</span>
						{v.recallData?.length ? (
							<div
								onMouseOver={() => popover3.current.classList.add("show")}
								onMouseOut={() => popover3.current.classList.remove("show")}
								onClick={() => setModal("recall-" + k)}
								className="hide-mobile"
							>
								<div className="compensation-popover" ref={popover3}>
									{t(
										"THIS_VEHICLE_WAS_INVOLVED_IN_A_RECALL_THAT_COULD_HAVE_CONTRIBUTED_TO_YOUR_ACCIDENT_"
									)}
								</div>
								<img
									src="/assets/nhtsa.png"
									height="43"
									style={{ marginLeft: 30 }}
								/>
								<img
									src="/assets/product-recall.jpg"
									height="43"
									style={{ marginLeft: 10 }}
								/>
							</div>
						) : null}
					</h2>
					{guilty ? (
						<div className="at-fault">
							<img src="/assets/icon-at-fault.svg" />
						</div>
					) : null}
					<table>
						<thead>
							<tr>
								<th>{t("DRIVER_INFO")}</th>
								<th>{t("VEHICLE_INFO")}</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>
									<section>
										<img src="/assets/icon-age.svg" />
										<div>
											<strong>{t("AGE")}</strong>
											{v.participants[0]?.person_age}
										</div>
									</section>
									<section>
										<img src="/assets/icon-gender.svg" />
										<div>
											<strong>{t("GENDER")}</strong>
											{lc(v.participants[0]?.gender)}
										</div>
									</section>
									<section className="hide-FL">
										<img src="/assets/icon-ethnicity.svg" />
										<div>
											<strong>{t("ETHNICITY")}</strong>
											{lc(v.participants[0]?.ethnicity)}
										</div>
									</section>
									<section>
										<img src="/assets/icon-residence.svg" />
										<div>
											<strong>{t("RESIDENCE_OF")}</strong>
											{zipInfo}
										</div>
									</section>
								</td>
								<td>
									<section className="hide-FL">
										<img src="/assets/icon-damage.svg" />
										<div>
											<strong>{t("DAMAGE_AREA")}</strong>
											{v.damage_area_1}
											<br />
											{v.damage_area_2}
										</div>
									</section>
									<section>
										<img src="/assets/icon-license-type.svg" />
										<div>
											<strong>{t("DRIVER_LICENSE_TYPE")}</strong>
											{lc(v.participants[0]?.driver_license_type)}
										</div>
									</section>
									<section>
										<img src="/assets/icon-id.svg" />
										<div>
											<strong>{t("VEHICLE_LICENSE_STATE_ID")}</strong>
											{v.vehicle_license_state}
										</div>
									</section>
									{v.vin_code && v.vin_code !== "0" && (
										<section>
											<img src="/assets/icon-vin.svg" />
											<div>
												<strong>VIN</strong>
												{v.vin_code?.substr(0, 4) +
													"XXXXXXXXX" +
													v.vin_code?.substr(-4)}
											</div>
										</section>
									)}
									<section>
										<img src="/assets/icon-insured.svg" />
										<div>
											<strong>{t("INSURED")}</strong>
											{lc(insurance)}
										</div>
									</section>
									{v.towing_company ? (
										<section>
											<img src="/assets/icon-tow.svg" />
											<div>
												<strong>{t("TOWING_COMPANY")}</strong>
												{v.towing_company}
											</div>
										</section>
									) : null}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
}
